import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findRank } from "../../../modules/reducers/productSearch/bestSeller";
import { bestSellersApi } from "../api/bestSelling/bestSellersApi";
import { brandIdMap } from "../const/brandIdMap";

const useBestSellerHook = () => {
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const rankList = useSelector((state) => state.bestSeller.rank);
  const dispatch = useDispatch();

  useEffect(() => {
    const brandCd = brandIdMap[brandId]?.cd || null;
    const api = bestSellersApi(brandCd);
    dispatch(findRank(api));
  }, [brandId]);

  return { rankList };
};

export default useBestSellerHook;
